import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import ComicForm from './components/comicForm/ComicForm';
import TransactionsPage from './components/transactions/TransactionsPage';
import LandingPage from './components/landing/LandingPage';
import { AuthProvider, useAuth } from './components/auth/AuthContext';
import { ReactNode, useEffect } from 'react';
import './App.css';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, login } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      login(window.location.href);
    }
  }, [isAuthenticated, login]);

  return isAuthenticated ? <>{children}</> : null;
};

const LoginRedirect = () => {
  const { isAuthenticated, login } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      login(window.location.origin + '/comic');
    }
  }, [isAuthenticated, login]);

  return isAuthenticated ? <Navigate to="/comic" replace /> : null;
};

const RegisterRedirect = () => {
  const { isAuthenticated, register } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      register(window.location.origin + '/comic');
    }
  }, [isAuthenticated, register]);

  return isAuthenticated ? <Navigate to="/comic" replace /> : null;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<PublicHome />} />
            <Route path="/register" element={<RegisterRedirect />} />
            <Route path="/login" element={<LoginRedirect />} />
            <Route
              path="/comic"
              element={
                <ProtectedRoute>
                  <ComicForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute>
                  <TransactionsPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

const PublicHome = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Navigate to="/comic" replace /> : <LandingPage />;
};

export default App;
